import { render, staticRenderFns } from "./siPurchaseOrderDetails.vue?vue&type=template&id=5d875c2d&scoped=true&"
import script from "./siPurchaseOrderDetails.vue?vue&type=script&lang=js&"
export * from "./siPurchaseOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./siPurchaseOrderDetails.vue?vue&type=style&index=0&id=5d875c2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d875c2d",
  null
  
)

component.options.__file = "siPurchaseOrderDetails.vue"
export default component.exports